/**
 * 关系邀请
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import * as Map from 'immutable';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';
import { _change_affinity_modal } from '../../store/Action';
import iconAffinityListEmptyPNG from './img/affinity-list-empty.png';

class AffinityInvite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      config: {},
      list: [],
      isMore: true,
      tab: 1,
      page: 1,
      size: 10,
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinityInviteModal);
    const props2 = Map.fromJS(this.props.base.affinityInviteModal);
    const props3 = Map.fromJS(prevProps.base.affinityDetailModal);
    const props4 = Map.fromJS(this.props.base.affinityDetailModal);
    if (!this.props.base.affinityInviteModal) {
    } else if (this.props.base.affinityInviteModal && !Map.is(props1, props2)) {
      this.showModal();
    } else if (
      !this.props.base.affinityDetailModal &&
      !Map.is(props3, props4)
    ) {
      this.getAffinityList();
    }
  }
  showModal = () => {
    this.setState(
      {
        visible: true,
        list: [],
        tab: 1,
      },
      () => {
        this.getAffinityConfig();
        this.getAffinityList();
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinityInviteModal: false,
      affinityInviteData: null,
    });
  };
  onChangeTab = (tab) => {
    this.setState(
      {
        list: [],
        tab,
      },
      () => {
        this.getAffinityList();
      }
    );
  };

  //邀请
  onIntive = (otherUid) => {
    _change_affinity_modal({
      affinityDetailModal: true,
      affinityDetailOtherUid: otherUid,
    });
  };

  getAffinityConfig = () => {
    HTTP._get_affinity_config().then((res) => {
      if (res.code == 200) {
        this.setState({ config: res.data });
      } else {
        message.error(res.message);
      }
    });
  };
  //获取关系缔结列表
  getAffinityList = (page = this.state.page) => {
    const { tab, size, list } = this.state;
    let params = {
      type: tab == 1 ? tab : 0,
      page,
      size,
    };

    HTTP._get_affinity_conclude_page(params).then((res) => {
      if (res.code == 200) {
        let data = res.data?.list || [];
        if (data?.length < size) {
          this.setState({ isMore: false });
        } else {
          this.setState({ isMore: true });
        }
        if (page != 1) {
          data = [...list, ...data];
        }
        this.setState({ list: data });
      } else {
        message.error(res.message);
      }
    });
  };
  onScroll = (e) => {
    const { page, isMore } = this.state;
    if (!isMore) return;
    if (e.scrollTop == e.contentScrollHeight - e.clientHeight) {
      this.getAffinityList(page + 1);
    }
  };

  seeDetail = (item) => {
    _change_affinity_modal({
      affinityApplyModal: true,
      affinityApplyOtherUid: item.otherUid,
      affinityApplyOrderNo: item.inviteOrderNo,
      affinityApplyType: 0,
    });
  };

  downTime = (time) => {
    let HH = Math.floor((time / 60 / 60) % 24);
    let mm = Math.floor((time / 60) % 60);
    let ss = Math.floor(time % 60);
    return `${HH < 10 ? '0' + HH : HH}:${mm < 10 ? '0' + mm : mm}:${ss < 10 ? '0' + ss : ss}`;
  };

  render() {
    const { loading, tab, list, visible, config, isMore } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1002}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`关系邀请`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="512px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box">
              <div className="tip">
                <div className="tip-icon"></div>
                <div className="tip-text">
                  和TA的亲密值达到<span>{config?.minValue}</span>
                  ，可以发起邀请，通过赠送信物缔结亲密关系
                </div>
              </div>
              <div className="affinity-tab">
                <div
                  className={`affinity-tab-item ${tab == 1 ? 'active' : ''}`}
                  onClick={() => this.onChangeTab(1)}
                >
                  可缔结关系用户
                </div>
                <div
                  className={`affinity-tab-item ${tab == 2 ? 'active' : ''}`}
                  onClick={() => this.onChangeTab(2)}
                >
                  暂不可缔结
                </div>
              </div>
              <Scrollbar
                ref={(el) => (this.scrollElement = el)}
                className="my-scroll-bar"
                style={{ height: '530px' }}
                onScroll={this.onScroll}
              >
                {list.length > 0 ? (
                  <div className="affinity-table">
                    {list.map((item) => (
                      <div className="affinity-table-item" key={item?.otherUid}>
                        <div className="affinity-table-left">
                          <div className="affinity-table-avatar">
                            <img
                              src={Util.transImgUrlToGame(item?.otherAvatar)}
                              alt=""
                            />
                          </div>
                          <div
                            className={`affinity-table-info ${tab == 1 ? '' : 'row'}`}
                          >
                            <div className="affinity-table-name">
                              {item?.otherNickName}
                            </div>
                            <div className="affinity-table-value">
                              亲密值：{item?.intimate || 0}
                            </div>
                          </div>
                        </div>
                        {tab == 1 && (
                          <div className="affinity-table-right">
                            {/** status 0:邀请中 10:已同意 20:已拒绝  30:已失效 40:待邀请*/}
                            {item.status == 0 ? (
                              <div
                                className="affinity-table-btn btn-2"
                                onClick={() => this.seeDetail(item)}
                              >
                                邀请中
                              </div>
                            ) : null}
                            {item.status == 10 ? (
                              <div className="affinity-table-btn ">已同意</div>
                            ) : null}
                            {item.status == 20 ? (
                              <>
                                <div className="affinity-table-btn btn-3">
                                  已拒绝
                                </div>
                                <p>
                                  {this.downTime(item.frozenTime)}后可重新邀请
                                </p>
                              </>
                            ) : null}

                            {item.status == 40 ? (
                              <div
                                className="affinity-table-btn btn-1"
                                onClick={() => this.onIntive(item.otherUid)}
                              >
                                邀请
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="affinity-empty">
                    <img src={iconAffinityListEmptyPNG} alt="空" />
                    {tab == 1 ? (
                      <p>暂无可缔结关系的好友</p>
                    ) : (
                      <p>暂无不可缔结关系的好友</p>
                    )}
                  </div>
                )}
                {!isMore && list.length > 0 && (
                  <div className="page-more">没有更多了</div>
                )}
              </Scrollbar>
            </div>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityInvite, { withRef: true })
);
